module.exports = __webpack_public_path__ + "7ef15a560cb031f35932927fb3ab6695.png";